export const mergeTimeSlotsAndClasses = (dayName, weekday, weekClasses, groupedTimeSlots) => {
  const classes = weekClasses[dayName] || [];
  const timeSlots = groupedTimeSlots[weekday]?.times || [];
  
  return [...classes, ...timeSlots];
};